import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SimpleModalData {
  title: string;
  content: string;
}

@Component({
  selector: 'ui-simple-modal',
  templateUrl: './simple-modal.component.html',
  styleUrls: ['./simple-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SimpleModalData,
    private _dialogRef: MatDialogRef<SimpleModalComponent>,
  ) {}

  public closeModal(event: Event): void {
    event.preventDefault();

    this._dialogRef.close();
  }
}
